import User from 'interfaces/User';

function getTrackingScripts(user: User | null): any[] {
  if (process.env.REACT_APP_ENABLE_TRACKING_SCRIPTS !== 'true' || !user) {
    return [];
  }
  return [
    {
      type: 'text/javascript',
      innerHTML: `window.hj('identify', '${user.id}', {
        fullname: '${user.fullname}',
        id: '${user.id}',
        email: '${user.email}'
      });`
    }
  ];
}

export default getTrackingScripts;
